export const SET_ACTIVE_BACKEND = 'SET_ACTIVE_BACKEND';
export const SET_ACTIVE_BACKEND_NAME = 'SET_ACTIVE_BACKEND_NAME';
export const SET_VALID_BACKEND = 'SET_VALID_BACKEND';
export const CLEAN_UP_BACKEND = 'CLEAN_UP_BACKEND';
